import { render } from "./TrendingPostScroll.vue?vue&type=template&id=ff1ba208"
import script from "./TrendingPostScroll.vue?vue&type=script&lang=js"
export * from "./TrendingPostScroll.vue?vue&type=script&lang=js"

import "./TrendingPostScroll.vue?vue&type=style&index=0&id=ff1ba208&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__